import styled from 'styled-components';

const Button = styled.button`
  padding: 8px 25px;
  width: 100%;
  margin-right: 0;
  border-radius: 0.25rem;
  font-family: 'RobotoRegular';
  font-size: 18px;
  background-color: #0097e6;
  border: none;
  color: #FFFFFF;
`;

export default Button;
